<template>
  <div>
    <b-card title="Anesthetia Form">
      <b-row>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Full Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.name"
              placeholder="Enter Patient Full Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient ID" label-for="ID">
            <b-form-input
              id="ID"
              v-model="addForm.patientId"
              placeholder="Enter Patient ID"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Gender" label-for="Gender">
            <v-select
              v-model="addForm.gender"
              :options="genderOption"
              placeholder="Gender"
            />
            <p v-if="errorForm.gender" class="ml-25 error">
              This field is required.
            </p>
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient BP" label-for="BP">
            <b-form-input
              id="BP"
              v-model="addForm.patientBP"
              placeholder="Enter Patient BP"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient SPO2" label-for="SPO2">
            <b-form-input
              id="SPO2"
              v-model="addForm.patientSPO2"
              placeholder="Enter Patient SPO2"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient HR" label-for="hr">
            <b-form-input
              id="hr"
              v-model="addForm.patientHR"
              placeholder="Enter Patient HR"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient RR" label-for="rr">
            <b-form-input
              type="number"
              id="rr"
              v-model="addForm.patientRR"
              placeholder="Enter Patient RR"
            />
          </b-form-group>
        </b-col>

        <b-col md="6" cols="12">
          <b-form-group label="Patient Last Blood Sugar" label-for="sugar">
            <b-form-input
              id="sugar"
              v-model="addForm.lastBloodSugar"
              placeholder="Enter Patient Last Blood Sugar"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Patient RR" label-for="rr">
            <b-form-input
              type="number"
              id="rr"
              v-model="addForm.PatientRR"
              placeholder="Enter Patient RR"
            />
          </b-form-group>
        </b-col>

        <b-col md="6" cols="12">
          <b-form-group
            label="Patient Last Blood Sugar Time"
            label-for="sugar-time"
          >
            <b-form-input
              id="sugar-time"
              v-model="addForm.lastBloodSugarTime"
              placeholder="Enter Patient Last Blood Sugar Time"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Age" label-for="Name">
            <b-form-input
              type="number"
              id="Name"
              v-model="addForm.age"
              placeholder="Enter Patient Age"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Patient Weight" label-for="Weight">
            <b-form-input
              type="number"
              id="Weight"
              v-model="addForm.weight"
              placeholder="Enter Patient Weight"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Drugs Given Last 24hr" label-for="drugs">
            <b-form-input
              id="drugs"
              v-model="addForm.drugs"
              placeholder="Enter Drugs Given Last 24hr"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Drug Dose" label-for="drug-dose">
            <b-form-input
              id="drug-dose"
              v-model="addForm.drugDose"
              placeholder="Enter Patient Drug Dose"
            />
          </b-form-group>
        </b-col>

        <b-col md="6" cols="12">
          <b-form-group label="Drug Given Time" label-for="drug-time">
            <b-form-input
              id="drug-dose"
              v-model="addForm.drugTime"
              placeholder="Enter Drug Given Time"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Last Food Intake Time" label-for="food">
            <b-form-input
              id="food"
              v-model="addForm.lastFoodIntakeTime"
              placeholder="Enter Last Food Intake Time"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Time of last drink" label-for="drink-time">
            <b-form-input
              id="drink-time"
              v-model="addForm.lastDrinkTime"
              placeholder="Enter Time of last drink"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Last Cigarette smoke time" label-for="cigarette">
            <b-form-input
              id="cigarette"
              v-model="addForm.lastCiggaretteSmokeTime"
              placeholder="Last Cigarette smoke time"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Hydartion Status" label-for="hydration">
            <b-form-input
              id="hydration"
              v-model="addForm.hydrationStatus"
              placeholder="Enter Hydartion Status"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Doctor Name" label-for="doctor">
            <b-form-input
              id="doctor"
              v-model="addForm.doctorName"
              placeholder="Enter Doctor Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group label="Pateint Relative Name" label-for="relative">
            <b-form-input
              id="relative"
              v-model="addForm.patientRelativeName"
              placeholder="Enter Pateint Relative Name"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Add Button -->

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printPreAnestheiaForm()"
        >
          Print Anesthetia Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="preanesthetiaFormPdf"
    >
      <section
        dir="ltr"
        class="pdf-content font-modify mx-5 my-2"
        slot="pdf-content"
      >
        <h2 class="text-center">مستشفى الوزيرية الاهلي</h2>
        <!-- form header -->
        <main class="mt-1">
          <h5 class="p-1 border border-2 border-dark text-center">
            Pre Anesthetia Note
          </h5>
          <!-- basic info -->
          <section
            class="d-flex justify-content-between mx-2 mt-1 align-items-start"
          >
            <div class="d-flex align-items-start">
              <span>ID:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.patientId }}
              </div>
            </div>
            <div class="d-flex align-items-start">
              <span>Date & Time:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
            </div>
          </section>
          <!-- end basic info -->
          <!-- patient name section -->
          <section class="d-flex mx-2 align-items-start">
            <span>Patient Name:</span>
            <div
              class="mx-1"
              style="text-decoration: underline; text-decoration-style: dotted"
            >
              {{ addForm.name }}
            </div>
          </section>
          <!-- end patient name section -->
          <!-- Patient info section -->
          <section class="d-flex mx-2 align-items-center">
            <div class="d-flex align-items-start">
              <span>Age:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.age }}
              </div>
            </div>
            <div class="d-flex align-items-center">
              <span>Sex:</span>
              <div class="border border-2 border-dark px-1 mx-1">M</div>
              <div class="border border-2 border-dark px-1 mx-1">F</div>
            </div>
            <div class="d-flex align-items-start">
              <span>Body Weight:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.weight }}
              </div>
            </div>
          </section>
          <!-- end patient info section -->
          <!-- test info section -->
          <section class="d-flex mx-2 align-items-center">
            <div class="d-flex align-items-start">
              <span>BP:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.patientBP }}
              </div>
            </div>
            <div class="d-flex align-items-start">
              <span>HR:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.patientHR }}
                /min
              </div>
            </div>

            <div class="d-flex align-items-start">
              <span>SPO2</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.patientSPO2 }}
                %
              </div>
            </div>
            <div class="d-flex align-items-start">
              <span>RR</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              >
                {{ addForm.patientRR }} /min
              </div>
            </div>
            <div class="d-flex align-items-start">
              <span>T</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
            </div>
          </section>
          <!-- end test info section -->
          <!-- Blood Sugar info section -->
          <div class="d-flex justify-content-between">
            <div>
              <section class="d-flex mx-2 align-items-center">
                <div class="d-flex align-items-start">
                  <span>Last Blood Sugar:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.lastBloodSugar }}
                  </div>
                </div>

                <div class="d-flex align-items-start">
                  <span>Time:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.lastBloodSugarTime }}
                  </div>
                </div>
              </section>
              <!-- end Blood Sugar section -->
              <!-- drgus section -->
              <section class="d-flex mx-2 mt-1 align-items-center">
                <div class="d-flex align-items-start">
                  <span>Grugs given last 24h:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.drugs }}
                  </div>
                </div>
              </section>
              <section class="d-flex mx-2 mt-1 align-items-center">
                <div class="d-flex align-items-start">
                  <span>Dose:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.drugDose }}
                  </div>
                </div>
                <div class="d-flex align-items-start">
                  <span>Time:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.drugTime }}
                  </div>
                </div>
              </section>
            </div>
            <!-- end drgus section -->
            <!-- food and drink section -->
            <div>
              <section class="d-flex flex-column align-items-end mx-2 mt-1">
                <div class="d-flex align-items-start">
                  <span>Time of the last food in take:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.lastFoodIntakeTime }}
                  </div>
                </div>
                <div class="d-flex align-items-start">
                  <span>Time of the last Drink:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.lastDrinkTime }}
                  </div>
                </div>
                <div class="d-flex align-items-start">
                  <span>Last Cigarrate Smoked:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.lastCiggaretteSmokeTime }}
                  </div>
                </div>
                <div class="d-flex align-items-start">
                  <span>Hydration Status:</span>
                  <div
                    class="mx-1"
                    style="
                      text-decoration: underline;
                      text-decoration-style: dotted;
                    "
                  >
                    {{ addForm.hydrationStatus }}
                  </div>
                </div>
              </section>
            </div>
          </div>
          <!-- end of food and drink section -->
          <!-- Asa stages table -->
          <table>
            <tr>
              <td>ASA</td>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>Emergency</td>
            </tr>
          </table>
          <!-- end of Asa stages table -->
          <!-- more info -->
          <section class="d-flex mx-2 align-items-start">
            <span
              >Anesthetia risk explained to the patient and his relative by
              myself Doctor: {{ addForm.doctorName }}</span
            >
            <div
              class="mx-1"
              style="text-decoration: underline; text-decoration-style: dotted"
            ></div>
          </section>
          <section class="d-flex mx-2 align-items-start">
            <span>Sign:</span>
            <div
              class="mx-1"
              style="text-decoration: underline; text-decoration-style: dotted"
            ></div>
          </section>
          <section class="d-flex mx-2 align-items-start">
            <span>Risk Points (in Arabic):</span>
            <div
              class="mx-1"
              style="text-decoration: underline; text-decoration-style: dotted"
            ></div>
          </section>
          <section class="d-flex mx-2 align-items-start">
            <span>Patient And Relative Name and Sign:</span>
            <div
              class="mx-1"
              style="text-decoration: underline; text-decoration-style: dotted"
            >
              {{ addForm.patientRelativeName }}
            </div>
          </section>
          <!-- end of more info -->
          <!-- Anesthetia drugs box -->
          <div class="border border-2 border-dark mt-1">
            <section class="d-flex mx-2 align-items-start">
              <span>Anesthetic Technique:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
            </section>
            <section class="d-flex mx-2 align-items-start">
              <span>Anesthetic Drugs:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
            </section>
            <section class="d-flex justify-content-end mx-2 align-items-start">
              <span>Anesthetist:</span>
            </section>
          </div>
          <h5 class="p-1 border border-2 border-dark text-center mt-1">
            Post Anesthetia Note
          </h5>
          <div class="">
            <table>
              <tr style="border: none">
                <th colspan="1" rowspan="2">Time</th>
                <th colspan="1" rowspan="2">FIO2</th>
                <th colspan="3">Vital Signs</th>
                <th colspan="1" rowspan="2">Respair</th>
                <th colspan="1" rowspan="2">CONSC</th>
                <th colspan="">N&V</th>
                <th colspan="">No</th>
                <th colspan=""></th>
                <th colspan="">Yes</th>
                <th colspan=""></th>
              </tr>
              <tr style="border: none">
                <td>HR</td>
                <td>BP</td>
                <td>SPO2</td>
                <td rowspan="2">Pain</td>
                <td>No</td>
                <td></td>
                <td>Yes</td>
                <td></td>
              </tr>
              <tr style="border: none">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Mild</td>
                <td>Moderate</td>

                <td colspan="2">Severe</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Drug Given</td>
                <td>Time</td>
                <td colspan="2">Dose</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
            </table>
          </div>
          <!-- Table -->

          <!-- end of table -->
          <!-- second table -->
          <b-row class="mt-1">
            <b-col cols="6">
              <h5 class="p-1 border border-2 border-dark text-center">
                Aldearte score at discharge
              </h5>
              <table>
                <tr>
                  <td>Activity</td>
                  <td>Resp</td>
                  <td>Circ</td>
                  <td>Consec</td>
                  <td>SPO2</td>
                  <td>Total</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="6">
                    Or the condition is pre asenthetic ballelane
                  </td>
                </tr>
              </table>
            </b-col>
            <b-col cols="6" class="mt-5 pt-2">
              <section class="d-flex mx-2 align-items-start">
                <span>Discharge To:</span>
                <div
                  class="mx-1"
                  style="
                    text-decoration: underline;
                    text-decoration-style: dotted;
                  "
                >
                  Ward
                </div>
                <div
                  class="mx-1"
                  style="
                    text-decoration: underline;
                    text-decoration-style: dotted;
                  "
                >
                  ICU
                </div>
              </section>
              <section class="d-flex mx-2 align-items-start">
                <span>Discharge Time:</span>
                <div
                  class="mx-1"
                  style="
                    text-decoration: underline;
                    text-decoration-style: dotted;
                  "
                ></div>
              </section>
            </b-col>
          </b-row>
          <!-- end of table -->
          <!-- Arabic section -->
          <div dir="rtl">
            <section class="d-flex mx-2 align-items-start">
              <span>تعليمات العناية بالمريض والعلاج:</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
            </section>
            <section
              class="d-flex justify-content-between mx-2 mt-1 align-items-center"
            >
              <div class="d-flex align-items-start">
                <span>رفع رأس المريض </span>
              </div>

              <div class="d-flex align-items-start">
                <span>اعطاء الاوكسجين</span>
              </div>
              <div class="d-flex align-items-start">
                <span> فحص السكر بالدم</span>
              </div>
            </section>
            <section class="mt-2 d-flex mx-2 align-items-start">
              <span>قياس الضغط والنبض كل :</span>
              <div
                class="mx-1"
                style="
                  text-decoration: underline;
                  text-decoration-style: dotted;
                "
              ></div>
              <span>حساب السوائل المعطاة والمفقودة</span>
            </section>
          </div>
          <!-- end patient name section -->
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th colspan="1">التاريخ</th>
                  <th colspan="1">الوقت</th>
                  <th colspan="4">المغذيات</th>
                  <th colspan="10">الادوية</th>
                  <th colspan="3">اخرى</th>
                  <th colspan="2">اسم الممرض وتوقيعة</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>12:00</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>14:00</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>22:00</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>24:00</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>06:00</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
    Datepicker,
  },

  data() {
    return {
      addForm: {
        name: '',
        age: '',
        history: '',
        companionName: '',
        adderss: '',
        occupation: '',
        gender: '',
      },
      errorForm: {
        name: '',
        age: '',
        history: '',
        companionName: '',
        adderss: '',
        occupation: '',
        gender: '',
      },
      genderOption: ['Male', 'Female'],
    };
  },
  methods: {
    printPreAnestheiaForm() {
      this.$refs.preanesthetiaFormPdf.generatePdf();
    },
  },
};
</script>

<style scoped>
body {
  color: #000;
  font-weight: bold;
}
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 100%;
  border: 1px solid;
  border-color: black;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 30px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
  font-size: 11px;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
